module.exports = __webpack_public_path__ + "img/sos-type-orange.819762ea.png";